import React, {useState, useEffect} from "react";
import { useParams, useNavigate } from "react-router-dom";
import BreadcrumbsBase from '../components/buttons/Breadcrumbs'
import AddSectionForm from "../components/forms/AddSection";

import { $host } from "../../../http";
import generateBreadcrumbs from "../utils/breadcrumbs";

const AddSection = () => {
    
    const { id: courseId } = useParams();
    const [breadcrumbs, setBreadcrumbs] = useState([])

    useEffect(() => {
        (async () => {
            try {
                const {data} = await $host.get(`/api/students/courses/paragraphs/${courseId}`)
                setBreadcrumbs(generateBreadcrumbs(data.breadcrumbs))
            } catch(e) {
                console.error(e)
            }
            
        })();
    }, [courseId])

    const navigate = useNavigate()

    const createParagraph = async data => {
        try {
            const formData = new FormData();
            Object.keys(data).forEach(it=>{
                formData.append(it, data[it])
            })

            const response = await fetch(`/api/teachers/paragraphs/create/${courseId}`, {
                method: 'POST',
                body: formData,
            });

            await response.json();
            navigate(`/teachers-cabinet/course/${courseId}`);

        } catch (e) {
            console.error(e);
        }
    };

    return ( 
        <section className="py-10 pl-6 px-6 w-full">
            <BreadcrumbsBase items={breadcrumbs} />
            <AddSectionForm onSubmit={createParagraph} />
        </section>
    )
}

export default AddSection